import { Button } from "@/components/ui/button";

export function CustomSubmitButton() {

  return (
    <div className="ml-1 mt-6 mb-6 flex justify-center">
      <Button type="submit" variant="default" size="default">Submit</Button>
    </div>
  );
}
